export default 'user-delete'
